<template>
  <el-tag size="mini" :type="processTypeClass">
    <i :class="['fas', processTypeIcon]"></i>
    <span>{{ processTypeLabel }}</span>
  </el-tag>
</template>

<script>
import constants from "../../constants";

export default {
  name: "vb-process-type-tag",
  props: ["processType"],

  watch: {
    processType() {
      this.initComponent();
    }
  },

  data() {
    return {
      processTypeIcon: null,
      processTypeLabel: null,
      processTypeClass: null
    };
  },

  created() {
    this.initComponent();
  },

  methods: {
    initComponent() {
      this.processTypeIcon = this.getProcessTypeIcon(this.processType);
      this.processTypeLabel = this.getProcessTypeLabel(this.processType);
      this.processTypeClass = this.getProcessTypeClass(this.processType);
    },

    getProcessTypeIcon(processType) {
      processType = processType != null ? parseInt(processType) : null;
      if (processType === constants.PROCESS_TYPE.CHUTRI) {
        return "fas fa-user";
      } else if (processType === constants.PROCESS_TYPE.PHOIHOP) {
        return "fas fa-users";
      } else if (processType === constants.PROCESS_TYPE.NHANDEBIET) {
        return "fas fa-info";
      } else {
        return "lv3";
      }
    },

    getProcessTypeLabel(processType) {
      processType = processType != null ? parseInt(processType) : null;
      if (processType === constants.PROCESS_TYPE.CHUTRI) {
        return "Chủ trì";
      } else if (processType === constants.PROCESS_TYPE.PHOIHOP) {
        return "Phối hợp";
      } else if (processType === constants.PROCESS_TYPE.NHANDEBIET) {
        return "Nhận để biết";
      } else {
        return "-";
      }
    },

    getProcessTypeClass(processType) {
      processType = processType != null ? parseInt(processType) : null;
      if (processType === constants.PROCESS_TYPE.CHUTRI) {
        return "danger";
      } else if (processType === constants.PROCESS_TYPE.PHOIHOP) {
        return "warning";
      } else if (processType === constants.PROCESS_TYPE.NHANDEBIET) {
        return "";
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/vb-process-type-tag.vue